export enum CallStatusLogMessages {
  DEAF_LEG_DISCONNECTED = 'Deaf leg disconnected',
  DEAF_LEG_CONNECTED = 'Deaf leg connected',
  DEAF_LEG_CONNECTING = 'Deaf leg connecting',
  DEAF_LEG_UNAVAILABLE = 'Deaf leg unavailable',
  HEARING_PARTICIPANT_CONNECTING = 'Hearing participant connecting',
  HEARING_PARTICIPANT_CONNECTED = 'Hearing participant connected',
  HEARING_PARTICIPANT_DISCONNECTED = 'Hearing participant disconnected',
}
